import { render } from "./formrelationship.vue?vue&type=template&id=22eb435a&scoped=true"
import script from "./formrelationship.vue?vue&type=script&lang=js"
export * from "./formrelationship.vue?vue&type=script&lang=js"

import "./formrelationship.vue?vue&type=style&index=0&id=22eb435a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22eb435a"]])

export default __exports__